import React, { useContext, useEffect, useRef, useState } from "react";
import { FaEye } from "react-icons/fa";
import { ReactComponent as Google } from "../assets/Google.svg";
import { ReactComponent as Twitter } from "../assets/Twitter.svg";
import { AppContextProvider } from "../App";
import { BsExclamationSquareFill } from "react-icons/bs";
import { Button } from "../utils/Button";
import Logo from "../assets/Logo.svg";

export const CreateNewPassword = () => {
  const [show, setShow] = useState(false);
  const [turnGreen, setTurnGreen] = useState(false);
  const [showCode, setShowCode] = useState(false);
  const [Errors, setErrors] = useState("");
  const { login, setLogin } = useContext(AppContextProvider);
  const ref = useRef(null);
  const [resentSent, setResentSent] = useState(null);

  useEffect(() => {
    if (show === true) {
      ref.current.type = "text";
    } else {
      ref.current.type = "password";
    }

    login && setShowCode(false);

    const resent = localStorage.getItem("resent");
    setResentSent(resent);
  }, [login, show, resentSent]);

  let errors = [];

  const validatePassword = (password) => {
    if (password.length < 8) {
      errors.push("Your password must be at least 8 characters");
    }
    if (password.search(/[a-z]/i) < 0) {
      errors.push("Your password must contain at least one letter.");
    }
    if (password.search(/[0-9]/) < 0) {
      errors.push("Your password must contain at least one digit.");
    }
    if (errors.length > 0) {
      setErrors(errors.join("\n"));
      setTurnGreen(false);
    } else {
      setErrors("");
      setTurnGreen(true);
    }
  };

  return (
    <div className="flex items-center justify-center h-screen max-w-sm px-4 mx-auto py-10 dark:text-white">
      <div className="h-auto w-full ">
        <a href="/" className="pb-10 text-3xl text-center flex justify-center">
          <img className="w-[56px]" src={Logo} alt="" />
        </a>
        <h1 className="text-center text-[28px] md:text-[32px]">Create New Password</h1>
        <form className="py-5">
          <div className={login ? "hidden" : "mb-5"}>
            <label
              for="password"
              className="block mb-2 text-lg font-medium text-gray-900 dark:text-white"
            >
              New Password
            </label>
            <input
              onChange={(e) => validatePassword(e.target.value)}
              ref={ref}
              placeholder=""
              type="password"
              id="password"
              className="focus:bg-white dark:text-white dark:border-gray-500  dark:bg-transparent bg-[#F8F8F8] border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-black outline-black focus:border-black block w-full p-2.5"
              required
            />
          </div>
          <p className={login ? "hidden" : "text-gray-400"}>
            Must be 8-25 characters and contain numbers and letters.
          </p>
          <p className="text-red-400">{!login && Errors}</p>

          <div
            className={login ? "hidden" : "flex items-center space-x-2 py-5"}
          >
            <div
              className={
                turnGreen
                  ? "w-20 h-[3px] rounded bg-green-500"
                  : "w-20 h-[3px] rounded bg-gray-300"
              }
            />
            <div
              className={
                turnGreen
                  ? "w-20 h-[3px] rounded bg-green-500"
                  : "w-20 h-[3px] rounded bg-gray-300"
              }
            />
            <div
              className={
                turnGreen
                  ? "w-20 h-[3px] rounded bg-green-500"
                  : "w-20 h-[3px] rounded bg-gray-300"
              }
            />
            <div
              className={
                turnGreen
                  ? "w-20 h-[3px] rounded bg-green-500"
                  : "w-20 h-[3px] rounded bg-gray-300"
              }
            />
            <div
              className={
                turnGreen
                  ? "w-20 h-[3px] rounded bg-green-500"
                  : "w-20 h-[3px] rounded bg-gray-300"
              }
            />
          </div>
          <div className="relative mb-5">
            <div className="flex items-center justify-between">
              <label
                for="confirmPassword"
                className="block mb-2 text-lg font-medium text-gray-900 dark:text-white"
              >
                Confirm New Password
              </label>
              <a
                href="/Pages/Reset"
                onClick={() => setLogin(true)}
                className={login ? "text-xs underline" : "hidden"}
              >
                Forgot?
              </a>
            </div>
            <input
              type="password"
              id="password"
              className="dark:text-white dark:border-gray-500  dark:bg-transparent text-md focus:bg-white bg-[#F8F8F8] border border-gray-300 text-gray-900 rounded-lg focus:ring-black outline-black focus:border-black block w-full p-2.5"
              required
            />
            {/* <p
              onClick={() => setShow(!show)}
              className="cursor-pointer absolute top-[43px] text-xs right-2"
            >
              Show
            </p> */}
          </div>

          <button
            type="submit"
            className="w-full text-lg px-5 py-2.5 font-medium text-center text-white bg-[#1c1c1c] rounded-lg dark:bg-white dark:text-black hover:text-black hover:bg-white/40 hover:border-2 focus:ring-4 focus:outline-none focus:ring-white"
          >
            Save
          </button>
        </form>
      </div>
    </div>
  );
};
